import React, { useEffect } from "react";
import { Col, Row } from "reactstrap";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import {
  setActiveTab,
  setPaginationPageNumber,
  TriggerFilterButtonApi,
} from "../../../../slices/common/reducer";
import { setUserFilterForm } from "../../../../slices/team/users/usersSlice";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, InputGroup } from "react-bootstrap";
import {
  filterDateOptions,
  handleFilterDateChange,
} from "../../../../Utils/CommonUtils";
import { USER_FROM_DATE, USER_TO_DATE } from "../../../../Utils/FilterDateKeys";
import { CiSearch } from "react-icons/ci";

const UserFilter = () => {
  const dispatch = useDispatch();

  const filterForm = useSelector((state) => state.users.filter.form);
  const roles = useSelector((state) => state.users.rolesData);

  const roleDropdown = roles.map((role) => {
    return {
      value: role.name,
      label: role.name,
    };
  });

  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  const handleInputChange = (name, value) => {
    dispatch(setUserFilterForm({ name, value }));
    resetTabAndPageNumber();
    dispatch(TriggerFilterButtonApi());
  };

  const handleClear = () => {
    dispatch(setUserFilterForm({ type: "reset" }));

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  const userOptions = [
    { value: "ACTIVE", label: "Active" },
    { value: "INACTIVE", label: "Inactive" },
  ];

  const isClearButtonDisabled = !Object.values(filterForm).some(
    (value) => value
  );

  return (
    <div className="filter-wrapper">
      <Form className="form-input">
        <Row>
          <Form.Group as={Col} className="col-md-4">
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                {" "}
                <CiSearch />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search for Code, Name..."
                name="filter_ref"
                id="name"
                className="user-searchbar"
                value={filterForm.filter_ref || ""}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
              />
            </InputGroup>
          </Form.Group>
          <Form.Group as={Col} className="col-md-4">
            <Select
              isClearable
              placeholder="Select Role"
              name="role_name"
              options={roleDropdown}
              value={
                roleDropdown?.find(
                  (itm) => itm.value === filterForm.role_name
                ) || null
              }
              onChange={(e) => handleInputChange("role_name", e ? e.value : "")}
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-3">
            <Select
              isClearable
              placeholder="All Status"
              name="status"
              options={userOptions}
              value={
                userOptions?.find((itm) => itm.value === filterForm.status) ||
                null
              }
              onChange={(e) => handleInputChange("status", e ? e.value : "")}
            />
          </Form.Group>
          {/* <Form.Group as={Col} className="col-md-1">
            <div>
              <button type="button" className="btn btn-outline-primary">
                <i className="ri-equalizer-fill me-1 align-bottom"></i>
              </button>
            </div>
          </Form.Group> */}
          <Form.Group as={Col} className="col-md-1">
            <div>
              <Button
                className="primary-outline"
                onClick={handleClear}
                disabled={isClearButtonDisabled}
              >
                Clear
              </Button>
            </div>
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
};

export default UserFilter;
